import { EventParentalControlRating } from 'services/data-manager/types';

export const parentalRatingContentKeys = {
    [EventParentalControlRating.UNKNOWN]: {
        title: 'CONTENT_RATING_VOD_GENERAL_AUDIENCE_TITLE',
        description: 'CONTENT_RATING_VOD_GENERAL_AUDIENCE_BODY',
    },
    [EventParentalControlRating.HU_GENERAL]: {
        title: 'CONTENT_RATING_VOD_GENERAL_AUDIENCE_TITLE',
        description: 'CONTENT_RATING_VOD_GENERAL_AUDIENCE_BODY',
    },
    [EventParentalControlRating.HU_UNRATED]: {
        title: 'CONTENT_RATING_VOD_GENERAL_AUDIENCE_TITLE',
        description: 'CONTENT_RATING_VOD_GENERAL_AUDIENCE_BODY',
    },
    [EventParentalControlRating.HU6]: {
        title: 'CONTENT_RATING_VOD_6_TITLE',
        description: 'CONTENT_RATING_VOD_6_BODY',
    },
    [EventParentalControlRating.HU12]: {
        title: 'CONTENT_RATING_VOD_12_TITLE',
        description: 'CONTENT_RATING_VOD_12_BODY',
    },
    [EventParentalControlRating.HU16]: {
        title: 'CONTENT_RATING_VOD_16_TITLE',
        description: 'CONTENT_RATING_VOD_16_BODY',
    },
    [EventParentalControlRating.HU18]: {
        title: 'CONTENT_RATING_VOD_18_TITLE',
        description: 'CONTENT_RATING_VOD_18_BODY',
    },
    [EventParentalControlRating.HU18_ADULT]: {
        title: 'CONTENT_RATING_VOD_ADULT_TITLE',
        description: 'CONTENT_RATING_VOD_ADULT_BODY',
    },
    [EventParentalControlRating.HU18_ADULT_UC]: {
        title: 'CONTENT_RATING_VOD_ADULT_TITLE',
        description: 'CONTENT_RATING_VOD_ADULT_BODY',
    },
};
